import './App.css';
import SocialSection from './components/SocialSection';

function App() {
  return (
    <main className="App">
      <SocialSection />
    </main>
  );
}

export default App;
